IREP.EuronicsIntegration = (function () {
    var options;

    var init = function (initOptions) {
        options = initOptions;

        var id = getParameterByName('id');
        if (id === null || id === "") {
            $('.euronics-addProfile').show();
            $('#updPassword').hide();

            if ($('[name="AcceptTC"]:checked').length === 0) {
                $('#saveProfile').css("background", "#CCC");
            }
            else {
                $('[name="AcceptTC"]:hidden').val(true);
            }
        }

        acceptTC();
        saveProfile();
        hideErrorMsg();
        passwordMatchValidation();
        showPasswordReset();
        resetPassword();       
    };

    var acceptTC = function () {
        $('#AcceptTC').on("click", function () {
            if ($('[name="AcceptTC"]:checked').length === 0) {
                $('#saveProfile').css("background", "#CCC");
            }
            else {
                $('#saveProfile').css("background", "#0071c5");
                $('[name="AcceptTC"]:hidden').val(true);
            }            
        });
    }

    var saveProfile = function () {
        $("#saveProfile").on("click", function () {
           
            if (!validation()) {
               return;
            }
            else {

                //check if profile exists already
                var profileCount = IREP.callApi({ url: "/euronics/profileCount", data: { username: document.getElementById("email").value }, type: "GET" }).done(function (data) {
                    if (data.profileCount > 0) {
                        $(".addProfile").hide();
                        $(".dvMerge").show();
                        $(".tbPassword").css("display", "inline-block");

                        $("#mergeProfiles").on("click", function () {
                            mergeProfiles();
                        });
                    }
                    else {
                        //create a new profile
                        IREP.callApi({ url: "/euronics/createNewProfile", data: { firstName: document.getElementById("fName").value, lastName: document.getElementById("lName").value, email: document.getElementById("email").value, storeId: $("#hdnStoreId").val() }, type: "POST" }).done(function (data) {

                            //get participant info
                            IREP.callApi({ url: "/euronics/getPaxUD", data: { username: document.getElementById("email").value } }).done(function (data) {
                            
                            //show redirect message 
                            $(".redirectMsg").show();
                            $(".redirectMsg").text("You are being redirected to https://retailedge.intel.com/");

                            function redirect() {
                                //redirect back to Euronics Integration page
                                window.location = location.origin + "/50/emea/euronics?paxuid=" + data.uid;
                            }
                            setTimeout(redirect, 3000);
                            })                            
                        });
                    }
                });

                hideErrorMsg();
            }
        });
    };

    var mergeProfiles = function () {
        //check password
        var password = document.getElementById("password").value;

        if (!validation()) {
            return;
        }

        //password is required
        if (password !== "") {
            var login = IREP.callApi({
                url: "/auth/login", data: { username: document.getElementById("email").value, active: true, cultureCode: "de-DE", password: password }, type: "POST"
            }).done(function (data) {
                if (data.isValid === true) {

                    //update participant's store
                    IREP.callApi({ url: "/euronics/updateParticipantStore", data: { username: document.getElementById("email").value, storeId: $("#hdnStoreId").val() }, type: "POST" }).done(function (data) {

                        //get participant info
                        IREP.callApi({ url: "/euronics/getPaxUD", data: { username: document.getElementById("email").value } }).done(function (data) {

                            //show redirect message 
                            $(".redirectMsg").show();
                            $(".redirectMsg").text("You are being redirected to https://retailedge.intel.com/");

                            function redirect() {                                
                                window.location = location.origin + "/50/emea/euronics?paxuid=" + data.uid;
                            }

                            setTimeout(redirect, 3000);
                        })
                    });                    
                }
                else {
                    //show an error
                    $(".error").show();
                    $(".error").text(data.errors);
                }               
            });
        }
        else {
            $(".reqPassword").show();
        }
    };

    var hideErrorMsg = function () {
        $("#fName").on("keyup", function () {
            $(".fnameError").hide();
        });

        $("#lName").on("keyup", function () {
            $(".lnameError").hide();
        });

        $("#email").on("keyup", function () {
            $(".emailError").hide();
        });

        $("#password").on("keyup", function () {
            $(".reqPassword").hide();
            $(".error").hide();
        });
    };

    var validation = function () {
        var fname = document.getElementById("fName").value;
        var lname = document.getElementById("lName").value;
        var email = document.getElementById("email").value;
        var isValidated = true;

        if ($('[name="AcceptTC"]:checked').length === 0)
        {
            $('#saveProfile').css("background", "#CCC");
           isValidated = false;
        }

        if (fname === null || fname === undefined || fname === "")
        {
            $(".fnameError").show();
            $(".fnameError").text("*This field is required.");
            isValidated = false;
        }
        if (lname === null || lname === undefined|| lname === "") {
            $(".lnameError").show();
            $(".lnameError").text("*This field is required.");
            isValidated = false;
        }       
        if (!emailValidation(email)) {
            $(".emailError").show();
            $(".emailError").text("*Please enter a valid email address.");
            isValidated = false;
        }
        return isValidated;
    };

    var emailValidation = function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    var showPasswordReset = function () {
        var username = getParameterByName('id');
        if (username !== null && username !== "") {
            $('.euronics-addProfile').hide();
            $('#updPassword').show();
            $(".euronics-profile-info").css('margin', '20px 0 0 0');
        }
    };

    var resetPassword = function () {
    
        $('#updatePassword').on('click', function () {
            $("#pwError").hide();

            var pass1 = document.getElementById('newPassword1');
            var pass2 = document.getElementById('newPassword2');

            if (pass1.value === null || pass1.value === "" || pass2.value === null || pass2.value === "" || pass1.value !== pass2.value)
            {
               // $("#pwError").show();
                //$("#pwError").text("Please choose and verify your password.");//103851
                return;
            }
            if (pass1.value == pass2.value) {

                serverChecks(document.getElementById("newPassword1").value); //Passwords must be at least 6 characters, and contain letters, numbers, and special characters.              
            }
        });
    };

    var serverChecks = function (pw) {
        var reqObj = { Password: pw };
        IREP.callApi("participant/CheckPasswordValidity", "GET", reqObj).done(function (data) {

            $("#pwError").hide();
            if (data.isValidPassword == false) {
                $("#pwError").show();
                $("#pwError").text("Passwords must be at least 6 characters, and contain letters, numbers, and special characters.");//103851
                return false;
            }
            else {
                //update password and log it in a tracker log
                IREP.callApi({ url: "/euronics/updateTracker", data: { username: getParameterByName('id'), newpassword: document.getElementById("newPassword1").value }, type: "POST" }).done(function (data) {
                    $("#pwError").show();
                    document.getElementById("pwError").style.color = "#297319";
                    $("#pwError").text("Your password was successfully updated.");

                    function redirect() {
                        window.location = "/50/emea/euronicsIntegration?storeid=" + getParameterByName("storeid");
                    }

                    setTimeout(redirect, 3000);

                });
            }
        }).fail(function (jqXHR, textStatus) {
            return false;
        });
    };

    var getParameterByName = function (name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    var passwordMatchValidation = function () {
        $('#newPassword2').on('keyup', function () {
            var pass1 = document.getElementById('newPassword1');
            var pass2 = document.getElementById('newPassword2');
            var message = document.getElementById('passwordError2');

            if (pass1.value == pass2.value && pass2.value === "") {
                pass2.style.backgroundColor = "#D38383";
                message.style.color = "#FF0000";
                message.innerHTML = "";
            }
            else if (pass1.value == pass2.value && pass2.value !== "" && pass2.value !== null) {
                pass2.style.backgroundColor = "#66cc66";                
                message.innerHTML = "Passwords Match!";
                message.style.color = "#0071c5";
            } else {
                pass2.style.backgroundColor = "#D38383";
                message.style.color = "#FF0000";
                message.innerHTML = "Passwords Do Not Match!";
            }
        });

        $('#newPassword1').on('keyup', function () {
            var pass1 = document.getElementById('newPassword1');
            var pass2 = document.getElementById('newPassword2');
            var message = document.getElementById('passwordError2');

            if (pass1.value == pass2.value && pass1.value === "")
            {
                pass2.style.backgroundColor = "#D38383";
                message.style.color = "#FF0000";
                message.innerHTML = "";
            }
            else if (pass1.value != pass2.value && pass2.value === "") {
                pass2.style.backgroundColor = "#D38383";
                message.style.color = "#FF0000";
                message.innerHTML = "";
            }            
            else if (pass1.value == pass2.value && pass1.value !== "") {
                pass2.style.backgroundColor = "#66cc66";
                message.innerHTML = "Passwords Match!";
                message.style.color = "#0071c5";
            } else {
                pass2.style.backgroundColor = "#D38383";
                message.style.color = "#FF0000";
                message.innerHTML = "Passwords Do Not Match!";
            }
        });
    }



    return {
            init: init
    };
})();



